import { Outlet, createFileRoute } from "@tanstack/react-router"
import { TodoSidebar, TodoSidebarCategory } from "toptaal-shared"
import { useTodosQuery } from "@/api/queries/todo/useTodosQuery"
import ScreenWrapper from "@/components/ScreenWrapper"
import {
  getTodoCategoryLabel,
  getTodoCategoryOrder,
  getTodoRoute,
  getTodoSidebarLabel,
  getTodoSidebarSubLabel,
} from "../../utils/todoUtils"

export const Route = createFileRoute("/todo")({
  component: LayoutComponent,
})

function LayoutComponent() {
  const { data: todos, isLoading } = useTodosQuery()

  const categories: TodoSidebarCategory[] = getTodoCategoryOrder()
    .map((category) => {
      const items = todos?.[category] ?? []
      const count = items.length > 0 ? items.length : undefined

      return {
        key: category,
        title: getTodoCategoryLabel(category),
        count,
        items: items.map((todo) => ({
          label: getTodoSidebarLabel(todo),
          subLabel: getTodoSidebarSubLabel(todo),
          route: getTodoRoute(todo),
        })),
        isLoading,
      }
    })
    .filter((category) => category.items.length > 0)

  return (
    <ScreenWrapper className="screen-height-minus-navbar !px-0 flex overflow-hidden">
      <TodoSidebar
        categories={categories}
        className="flex flex-col bg-primary-light-blue w-1/3 p-8 overflow-y-auto min-h-0"
      >
        <h2 className="font-bold text-xl mb-4">To do's</h2>
      </TodoSidebar>

      <div className="flex-1 bg-white p-8 overflow-y-auto min-h-0">
        <Outlet />
      </div>
    </ScreenWrapper>
  )
}
